// extracted by mini-css-extract-plugin
export default {"newsImgsTabs":"index_newsImgsTabs_PPEup","tabsWrapper":"index_tabsWrapper_oWjdI","tabItem":"index_tabItem_603uo","hover":"index_hover_5eGx0"};